import { render, staticRenderFns } from "./UpdateUsersWorkspace.vue?vue&type=template&id=5aa2bcc4"
import script from "./UpdateUsersWorkspace.vue?vue&type=script&lang=js"
export * from "./UpdateUsersWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports